export default __webpack_public_path__ + "static/product-unit-6-past-future-0f3ee2fd946f9cddefa9cc8ee9ff808c.png";